import { ArtistGenreUnionType, OrganizationUnitType } from '@api';
import {
  CheckboxField,
  MultiSelectField,
  SelectField,
  TextareaField,
  TextField,
} from '@hypeit-gmbh/hypeit-ui';
import { Space, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { FormActions } from '../FormActions';

type ArtistFormFieldsPropsType = {
  artistGenres: ArtistGenreUnionType[];
  organizationUnits: OrganizationUnitType[];
  canEditOrganizationUnit: boolean;
  canEditAbbreviation: boolean;
  organizationUnitFieldName?: 'organizationUnit' | 'defaultOrganizationUnit';
  onClose: () => void;
};

export const ArtistFormFields: React.FC<ArtistFormFieldsPropsType> = ({
  artistGenres,
  organizationUnits,
  canEditOrganizationUnit,
  canEditAbbreviation,
  organizationUnitFieldName = 'organizationUnit',
  onClose,
}) => {
  const { t } = useTranslation('artists');

  const genreOptions = artistGenres.map((genre) => ({
    label: t(`GENRES.${genre}`),
    value: genre,
  }));

  const options = organizationUnits.map((organizationUnit) => ({
    value: organizationUnit.id,
    label: organizationUnit.name,
  }));

  return (
    <Stack gap="xs">
      <TextField
        fieldName="name"
        label={t('ARTIST_FORM_FIELDS.NAME_LABEL')}
        required
      />
      {canEditAbbreviation && (
        <TextField
          fieldName="abbreviation"
          label={t('ARTIST_FORM_FIELDS.ABBREVIATION_LABEL')}
        />
      )}
      <TextField
        fieldName="website"
        label={t('ARTIST_FORM_FIELDS.WEBSITE_LABEL')}
      />
      <TextField
        fieldName="artistLink"
        label={t('ARTIST_FORM_FIELDS.ARTIST_LINK_LABEL')}
      />
      <MultiSelectField
        fieldName="genres"
        label={t('ARTIST_FORM_FIELDS.GENRES_LABEL')}
        data={genreOptions}
        searchable
      />
      <CheckboxField
        fieldName="isDomesticArtist"
        label={t('ARTIST_FORM_FIELDS.IS_DOMESTIC_ARTIST_LABEL')}
      />
      <CheckboxField
        fieldName="isFemaleAct"
        label={t('ARTIST_FORM_FIELDS.IS_FEMALE_ACT_LABEL')}
      />
      <TextareaField
        fieldName="comment"
        label={t('ARTIST_FORM_FIELDS.COMMENT_LABEL')}
      />
      {canEditOrganizationUnit && (
        <SelectField
          fieldName={organizationUnitFieldName}
          label={t('ARTIST_FORM_FIELDS.ORGANIZATION_UNIT_LABEL')}
          data={options}
          clearable
        />
      )}
      <Space />
      <FormActions
        onCancel={onClose}
        saveButtonText={t('SAVE_BUTTON', { ns: 'common' })}
        cancelButtonText={t('CANCEL_BUTTON', { ns: 'common' })}
      />
    </Stack>
  );
};
